import {
  subtitlescontainer, subtitles
} from '../../../shared/stylesheets/video.css'

export const fakeSubtitles = (videoElement, subtitleId) => {
  const subtitleArray = subtitle[subtitleId]
  addSubtitle(videoElement, subtitleArray)
  videoElement.setAttribute('data-already-subtitled', true)
  let tracks = videoElement.textTracks[0]

  if (!tracks) {
    return
  }

  videoElement.controls = false;
  tracks.mode = 'hidden'
  let cues = tracks.cues

  let subtitleContainer = videoElement.parentElement.querySelector(`.${subtitlescontainer}`)

  const replaceText = (text) => {
    subtitleContainer.innerHTML = `<span class="${subtitles}">${text}</span>`
  }
  const hideText = () => {
    subtitleContainer.style.display = 'none'
  }

  const showText = () => {
    subtitleContainer.style.display = 'block'
  }

  const cueEnter = (text) => {
    replaceText('text');
    showText();
  }

  const cueExit = () => {
    hideText();
  }
  const videoLoaded = (e) => {
    for (let i in cues) {
      let cue = cues[i];
      try {
        cue.onenter = () => {
          replaceText(cue.text);
          showText();
        }
        cue.onexit = hideText
      } catch (ex) {
        // hehe
      }

    }
  }
  videoElement.addEventListener('play', videoLoaded)


}


function addSubtitle(videoElement, arr) {
  const track = videoElement.addTextTrack('subtitles', 'Norsk', 'no');
  try {
    arr.forEach(a => track.addCue(new VTTCue(a.start, a.end, a.text)))
  } catch (ex) {
    arr.forEach(a => track.addCue(new TextTrackCue(a.start, a.end, a.text)))
  }

}

const standup_homs = [
  {
    start: 1,
    end: 3,
    text: 'Her var syriske opprørsstyrker inntil nylig.'
  },
  {
    start: 4,
    end: 8,
    text: 'I dette huset på frontlinjen hadde de sine skarpskytterposisjoner.'
  },
  {
    start: 9,
    end: 12,
    text: 'Nå er de blitt drevet ut av den syriske regjeringshæren,'
  },
  {
    start: 13,
    end: 17,
    text: 'og dette er det siste nabolaget i Homs by som de mistet.'
  },
]

const standup_aleppo = [
  {
    start: 0.5,
    end: 5.5,
    text: 'Gamlebyen i Aleppo var en av de mest atmosfæriske byene i hele midtøsten.'
  },
  {
    start: 5.5,
    end: 9.5,
    text: 'Her var det masse butikker og masse folk.'
  },
  {
    start: 9.5,
    end: 14.5,
    text: 'Nå er det nesten ingenting igjen. Det er ikke et menneske i denne gaten.'
  },
  {
    start: 16.5,
    end: 20,
    text: 'Det føles nesten som å bevege seg gjennom en spøkelsesby.'
  },
]

const standup_maskaneh = [
  {
    start: 1,
    end: 6.5,
    text: 'Her var IS inntil nylig. Dette er rester av et av deres skilt.'
  },
  {
    start: 6.5,
    end: 10.5,
    text: 'Nå har den syriske hæren drevet dem tilbake i dette området.'
  },
  {
    start: 10.5,
    end: 14,
    text: 'De blir presset tilbake i hele Syria.'
  },
]

const subtitle = {
  standup_homs,
  standup_aleppo,
  standup_maskaneh
}



// WEBPACK FOOTER //
// ./src/client/sections/video/subtitles.js